function pickId(previewId: number, prodId: number) {
  if (process.env.NEXT_PUBLIC_STAGE === 'production') return prodId
  return previewId
}

export const ArtistsIds = {
  banksy: pickId(1213, 1229),
  invader: pickId(1437, 1429),
  damienHirst: pickId(1229, 1289),
  davidShrigley: pickId(1385, 1392),
  wernerBronkhorst: pickId(1610, 1691),
  andrewScott: pickId(1603, 1603),
  davidHockney: pickId(1285, 1337),
  gerhardRichter: pickId(1205, 1227),
  aiWeiWei: pickId(1337, 1358),
  kaws: pickId(1455, 1438),
  traceyEmin: pickId(1347, 1373),
}
